import { API_CONFIG } from "config/api.config";
import PayloadModel from "model/_payload/payload.schema";
import EarningModel from "model/transactions/earning.schema";
import EarningsSchema from "model/transactions/earnings.schema";
import LinksModel from "model/transactions/links.schema";
import { createBaseApi } from "../baseApi";

export const transactionsApi = createBaseApi("transactions", "/transactions").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Transaction Partners
    getEarnings: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "/earnings",
          method: "GET",
          params: payload,
        };
      },
      transformResponse: (response) => {
        return EarningsSchema.jsonToModel(response);
      },
    }),

    // Export Transaction Partners
    exportEarnings: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "exports/earnings",
          method: "GET",
          params: payload,
          responseHandler: (response) => response.blob(),
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),

    // Earning Partner
    getEarningPartner: builder.query({
      query: (id) => {
        return {
          url: `/earnings/partner/${id}`,
          method: "GET",
        };
      },
      // Transform response data
      transformResponse: (response) => {
        return EarningModel.jsonToModel(response);
      },
    }),

    // Earning Links
    getEarningLinks: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: `/earnings/links/${value.id}`,
          method: "GET",
          params: payload,
        };
      },
      transformResponse: (response) => {
        return LinksModel.jsonToModel(response);
      },
    }),

    // Export Transactions
    exportEarningLinks: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: `exports/earnings/links/${value.id}`,
          method: "GET",
          params: payload,
          responseHandler: (response) => response.blob(),
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const {
  useGetEarningsQuery,
  useLazyExportEarningsQuery,

  useGetEarningPartnerQuery,
  useGetEarningLinksQuery,
  useLazyExportEarningLinksQuery,
} = transactionsApi;
